<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="emitChange">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-gestao-entrega-filtro ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      label="Procure pelo código da compra, descrição ou código do produto"
                      v-model="searchText"
                      style="max-width: 500px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GestaoEntregaFiltro from './GestaoEntregaFiltro.vue';

export default {
  computed: {
    ...mapGetters('gestaoEntrega', ['statusOptions', 'hasCustomFilters']),
    selectedStatus: {
      get() {
        return this.$store.getters['gestaoEntrega/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('gestaoEntrega/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['gestaoEntrega/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('gestaoEntrega/searchText', searchText);
      },
    },
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
  },
  components: {
    pxGestaoEntregaFiltro: GestaoEntregaFiltro,
  },
};
</script>
